export enum PayNowDirectType {
  CaPay = 'CaPay',
  Byo = 'Byo'
}
